import React, { useCallback, useContext, useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, useParams } from "react-router-dom";
import BusinessLogo from "../assets/images/Logo.png";
import PayattitudeCardImage from "../assets/images/payattitude.png";
import CardContext from "../store/card-context";
import useHttp from "../hooks/use-http";

const PayAttitudeCardNav = () => {
  const { cardDetails } = useContext(CardContext);
  const { scheme } = cardDetails;
  const [merchantData, setMerchantData] = useState({});
  const [merchantLogo, setMerchantLogo] = useState();
  const { isLoading, sendRequest: MerchantInfo } = useHttp();

  const { id } = useParams();

  const getMerchantInfo = (data) => {
    setMerchantData(data);
    if (data?.data?.logo) {
      setMerchantLogo(data?.data?.logo);
    } else {
      setMerchantLogo(BusinessLogo);
    }
  };

  const fetchMerchantInfo = useCallback(async () => {
    MerchantInfo(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/sandbox/checkout/${id}`,
        headers: {
          "ngrok-skip-browser-warning": "true",
          "Content-Type": "application/json",

        },
      },
      getMerchantInfo
    );
  }, [MerchantInfo, id]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchMerchantInfo();
    };

    fetchData();
    //console.log('Payattitude Card Payment')
  }, [fetchMerchantInfo]);

  const activeClass =
    "flex items-center gap-3 justify-center rounded-r-[5px] py-[30px] h-[63px] w-[228px] bg-white border-solid border-l border-deepBlue text-deepBlue font-extrabold";
  return (
    <div className="">
      <div className="flex md:gap-40">
        <div className="md:bg-[rgba(var(--primary-rgb),0.4)] md:bg-[url('../src/assets/images/background.png')] md:bg-no-repeat md:bg-cover md:bg-opacity-[35%] md:w-[30%] min-h-screen hidden lg:block">
          <div className="flex items-center">
            <img
              src={merchantLogo}
              alt="logo"
              className="w-[110px] h-auto pl-2 md:pl-6"
            />
            {merchantData?.data?.appName && (
              <p className="text-xl">{merchantData?.data?.appName}</p>
            )}
          </div>{" "}
          {/* <img
            src={BusinessLogo}
            alt="logo"
            className="w-[92px] h-[63px] ml-2"
          /> */}
          <div className="">
            <div className="mt-[219px]  hidden lg:block">
              <h1 className="text-xl font-semibold text-lightBlack md:flex md:justify-end md:px-7">
                Payment Options
              </h1>
              <div className="md:flex md:flex-col md:items-end mt-4">
                <NavLink
                  className={({ isActive }) => (isActive ? activeClass : "")}
                >
                  <img
                    src={PayattitudeCardImage}
                    className="w-[37.09px] h-[15px]"
                    alt="cardLogo"
                  />
                  {/* <img
                    src={scheme === "verve" ? VerveImage : AfrigoImage}
                    className="w-[33px] h-[33px]"
                    alt="cardImage"
                  /> */}
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <main className="mx-auto md:w-[70%] md:mt-[100px] mt-[70px] relative">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PayAttitudeCardNav;
